import { axiosIns } from "./axios";

const get = (url, queryData = {}) => {
    return axiosIns.get(url, { params: queryData })
        .then((response) => {
            return Promise.resolve(response.data);
        }).catch((error) => {
            return Promise.reject(error);
        });
}

const post = (url, queryData,headers={}) => {
    return axiosIns.post(url, queryData,{headers})
        .then((response) => {
            return Promise.resolve(response.data);
        }).catch((error) => {
            return Promise.reject(error);
        });
}

const put = (url, queryData) => {
    return axiosIns.put(url, queryData)
        .then((response) => {
            return Promise.resolve(response.data);
        }).catch((error) => {
            return Promise.reject(error);
        });
}

const patch = (url, queryData) => {
    return axiosIns.patch(url, queryData)
        .then((response) => {
            return Promise.resolve(response.data);
        }).catch((error) => {
            return Promise.reject(error);
        });
}

export { get, post, put, patch }
